import React, { useMemo } from "react";

const COLORS = ["#FF5F65", "#1E293B", "#159C78", "#5865F2", "#F04461", "#F0A93B"];

// Lightweight, dependency-free confetti burst (CSS keyframes). Plays once on mount.
export function Confetti({ count = 26 }) {
  const pieces = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        left: Math.random() * 100,
        delay: Math.random() * 0.25,
        duration: 1.8 + Math.random() * 1.2,
        size: 7 + Math.random() * 7,
        color: COLORS[i % COLORS.length],
        round: Math.random() > 0.5,
        drift: (Math.random() - 0.5) * 80,
      })),
    [count]
  );

  return (
    <div style={{ position: "fixed", inset: 0, pointerEvents: "none", overflow: "hidden", zIndex: 60 }}>
      <style>{`@keyframes rc-confetti-fall{0%{transform:translateY(-20px) translateX(0) rotate(0);opacity:1}100%{transform:translateY(105vh) translateX(var(--rc-drift)) rotate(540deg);opacity:0}}`}</style>
      {pieces.map((p, i) => (
        <span
          key={i}
          style={{
            position: "absolute",
            top: 0,
            left: `${p.left}%`,
            width: p.size,
            height: p.size,
            background: p.color,
            borderRadius: p.round ? "50%" : 2,
            "--rc-drift": `${p.drift}px`,
            animation: `rc-confetti-fall ${p.duration}s ${p.delay}s cubic-bezier(0.2,0.6,0.4,1) forwards`,
          }}
        />
      ))}
    </div>
  );
}
